<script context="module">
  export const changeMode = () => {
    document.querySelector("body").classList.toggle("darkmode");
  };
</script>
